import { Toaster as ToasterComponent } from '@1trading/react';
import type React from 'react';
import { useTheme } from '@/lib/theme-provider';

// The library Toaster feeds the raw HSL triplets (--popover etc.) straight into
// sonner's --normal-* vars, yielding a transparent toast; wrap them in hsl() here.
export const Toaster = (props: React.ComponentProps<typeof ToasterComponent>) => {
  const { theme } = useTheme();

  return (
    <ToasterComponent
      style={
        {
          '--border-radius': 'var(--radius)',
          '--normal-border': 'hsl(var(--border))',
          '--normal-bg': 'hsl(var(--background))',
          '--normal-text': 'hsl(var(--foreground))',
        } as React.CSSProperties
      }
      theme={theme}
      {...props}
    />
  );
};
Toaster.displayName = 'Toaster';
